import { useAtomValue } from 'jotai';
import FavoriteButton, { FavoriteButtonVariant } from '../common/components/FavoriteButton';
import { canAccessWishlistAtom } from './state';
import useWishlistProduct from './useWishlistProduct';

interface WishlistProductButtonProps {
  supplierId: string;
  productSku: number;
  variant?: FavoriteButtonVariant;
}

export default function WishlistProductButton({
  supplierId,
  productSku,
  variant,
}: WishlistProductButtonProps): React.JSX.Element | null {
  const canAccessWishlist = useAtomValue(canAccessWishlistAtom);
  const { isInWishlist, isLoading, toggleFavorite } = useWishlistProduct(supplierId, productSku);

  if (!canAccessWishlist) {
    return null;
  }

  return (
    <FavoriteButton
      isActive={isInWishlist}
      disabled={isLoading}
      onClick={() => toggleFavorite()}
      variant={variant}
    />
  );
}
